import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../Context/AuthContext';
import { sidebarCSS, sidebarOverlayCSS } from './Sidebar.css';

const ROLE_LABELS = {
    '1': 'Admin Pei',
    '2': 'Vendedor Pei',
    '3': 'Admin Trim',
    '4': 'Vendedor Trim',
};

const ADMIN_GROUPS = [
    {
        label: 'Operación',
        items: [
            { path: '/admin/dashboard', label: 'Dashboard', icon: 'pi pi-th-large' },
            { path: '/admin/gestion-usuarios', label: 'Gestión de Usuarios', icon: 'pi pi-users' },
            { path: '/admin/usuarios', label: 'Usuarios', icon: 'pi pi-users' },
            { path: '/admin/cotizaciones', label: 'Cotizaciones', icon: 'pi pi-file' },
        ],
    },
    {
        label: 'Configuración',
        items: [
            { path: '/admin/valores-residuales', label: 'Valores residuales', icon: 'pi pi-cog' },
            { path: '/admin/parametros-gestoria', label: 'Parámetros gestoría', icon: 'pi pi-cog' },
            { path: '/admin/direccion-placas', label: 'Dirección por placas', icon: 'pi pi-cog' },
            { path: '/admin/contrasena', label: 'Contraseña', icon: 'pi pi-cog' },
            { path: '/admin/clave-cotizador', label: 'Clave cotizador', icon: 'pi pi-cog' },
        ],
    },
];

const getInitials = (name = '') =>
    name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((w) => w[0]?.toUpperCase())
        .join('') || '?';

export const Sidebar = ({ groups = ADMIN_GROUPS, mobileOpen = false, onMobileClose }) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { authInfo } = useContext(AuthContext);
    const name = authInfo?.user?.name || 'Admin';
    const role = ROLE_LABELS[String(authInfo?.user?.type_user ?? '')] || 'Usuario';

    useEffect(() => {
        if (!mobileOpen) return undefined;
        const onKey = (e) => {
            if (e.key === 'Escape') onMobileClose?.();
        };
        window.addEventListener('keydown', onKey);
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            window.removeEventListener('keydown', onKey);
            document.body.style.overflow = prevOverflow;
        };
    }, [mobileOpen, onMobileClose]);

    useEffect(() => {
        if (!mobileOpen) return undefined;
        const onResize = () => {
            if (window.innerWidth >= 1024) onMobileClose?.();
        };
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, [mobileOpen, onMobileClose]);

    const handleItemClick = (path) => {
        navigate(path);
        if (mobileOpen) onMobileClose?.();
    };

    return (
        <>
            {mobileOpen && (
                <div
                    css={sidebarOverlayCSS()}
                    onClick={onMobileClose}
                    aria-hidden="true"
                />
            )}
            <aside
                css={sidebarCSS()}
                className={mobileOpen ? 'is-mobile-open' : ''}
                aria-label="Navegación principal"
            >
                {groups.map((group) => (
                    <div key={group.label} className="sb-group">
                        <div className="sb-eyebrow">{group.label}</div>
                        <div className="sb-items">
                            {group.items.map((item) => {
                                const isActive =
                                    pathname === item.path ||
                                    pathname.startsWith(`${item.path}/`);
                                return (
                                    <button
                                        key={item.path}
                                        type="button"
                                        className={`sb-item ${isActive ? 'is-active' : ''}`}
                                        onClick={() => handleItemClick(item.path)}
                                        aria-label={item.label}
                                        aria-current={isActive ? 'page' : undefined}
                                        title={item.label}
                                    >
                                        <span className="sb-icon">
                                            <i className={item.icon} />
                                        </span>
                                        <span className="sb-label">{item.label}</span>
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                ))}

                <div className="sb-push" />

                <div className="sb-footer">
                    <div className="sb-avatar">{getInitials(name)}</div>
                    <div className="sb-user">
                        <div className="sb-user-name">{name}</div>
                        <div className="sb-user-role">{role}</div>
                    </div>
                </div>
            </aside>
        </>
    );
};

export default Sidebar;
